import React from 'react'
import moment from 'moment'
import TextReadWidget, { TextReadWidgetProps } from './TextWidget'

interface DateReadWidgetProps extends Omit<TextReadWidgetProps, 'value'> {
    value?: string
}

const DateReadWidget: React.FC<DateReadWidgetProps> = ({
    value = '',
    ...props
}) => {
    return (
        <TextReadWidget
            value={(value) ? moment(value).format('L') : undefined}
            {...props}
        />
    )
}

export default DateReadWidget
